import { useState, useEffect } from "react";
import { statusAgendamento } from "../Agendamento/AgendamentoContext";
import { Atendimento } from "../../api/api";
import { useAuth } from "../Auth/AuthContext";

/** It lists Atendimentos Grupo registered in the system */
export const useList = ({
  isAgendamento = false,
  initialSetorAtendimento = {},
  initialProfissional = {},
  enabled = true,
  sorting = "dataAgendamento:asc",
}) => {
  const [setorAtendimento, setSetorAtendimento] = useState(
    initialSetorAtendimento
  );
  const [profissional, setProfissional] = useState(initialProfissional);
  const [isLoading, setIsLoading] = useState(false);
  const [agendamentos, setAgendamentos] = useState([]);
  const { user } = useAuth();
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const ITEMS_PER_PAGE = 20;

  const load = async (currentPage = 1, append = false) => {
    setIsLoading(true);

    const filter = isAgendamento
      ? {
          status: statusAgendamento.emAberto,
        }
      : {
          status_ne: statusAgendamento.emAberto,
        };

    const { data } = await Atendimento(user.jwt).get({
      atendimentoEmGrupo: true,
      _sort: sorting,
      _start: (currentPage - 1) * ITEMS_PER_PAGE,
      _limit: ITEMS_PER_PAGE,
      ...filter,
      setorAtendimento: setorAtendimento?.id,
      profissional: profissional?.id,
    });

    setHasMore(!(data.length < ITEMS_PER_PAGE));

    if (append) {
      setAgendamentos((prev) => [...prev, ...data]);
    } else {
      setAgendamentos(data);
    }

    setIsLoading(false);
  };

  const loadMore = async () => {
    if (!hasMore || isLoading) return false;

    const nextPage = page + 1;
    setPage(nextPage);
    await load(nextPage, true);

    return hasMore;
  };

  useEffect(() => {
    setProfissional(initialProfissional);
    setSetorAtendimento(initialSetorAtendimento);
  }, [initialProfissional?.id, initialSetorAtendimento?.id]);

  useEffect(() => {
    if (!enabled) return;

    setPage(1);
    setHasMore(false);
    load(1, false);
  }, [setorAtendimento?.id, profissional?.id, enabled]);

  return {
    agendamentos,
    isLoading,
    loadMore,
    hasMore,
    setorAtendimento,
    setSetorAtendimento,
    load,
    profissional,
    setProfissional,
  };
};
